import React, {useEffect, useState} from "react";
import PropTypes from "prop-types";
import axios from "axios";
import {getApiBaseUrl} from "../../../utils/baseUrl";

const PartnersModal = ({
                           dataUser,
                           pagePerso,
                           setPagePerso,
                           iframe,
                           setIframe,
                       }) => {
    const [societe, setSociete] = useState({});
    const logo = `${getApiBaseUrl()}/assets/partenaires/${dataUser.idSociete}.png`;
    useEffect(() => {
        const url = `${getApiBaseUrl()}/checkSociete/`;
        const token = window.localStorage.getItem("id");
        const idUser = window.localStorage.getItem("idUser");
        const email = window.localStorage.getItem("email");
        if (dataUser.idSociete != 0 || dataUser.idSociete != "0") {
            const payload = {
                "session": {
                    "id": token,
                    "email": email,
                    "idUser": idUser
                },
                "idSociete": dataUser.idSociete
            };
            axios.post(url, payload, {withCredentials: true})
                .then((res) => {
                    setSociete({
                        id: dataUser.idSociete,
                        pagePerso: res.data.pagePerso,
                        title: res.data.title,
                        text: res.data.text,
                        button: res.data.button,
                        color: res.data.color,
                        backgroundColor: res.data.backgroundColor
                    });
                    if (res.data.pagePerso == 1) setPagePerso(true);
                })
                .catch((err) => {
                    console.log("err", err);
                });
        }
    }, [dataUser.idSociete]);

    return (
        <div>
            {pagePerso &&
                <div className={"partnerModal-container"} style={{
                    backgroundColor: `#${societe.backgroundColor}`
                }}>
                    <div className={"partnerModal-container-infos"}>
                        <h3 style={{color: `#${societe.color}`}}>{societe.title}</h3>
                        <p style={{color: `#${societe.color}`}}>{societe.text}</p>
                        <button
                            style={{backgroundColor: `#${societe.color}`}}
                            onClick={(e) => {
                                e.preventDefault();
                                setIframe(true);
                            }}>{societe.button}</button>
                    </div>
                    <div className={"partnerModal-container-logo"}>
                        <img src={logo}/>
                    </div>
                </div>
            }
        </div>

    );
};

PartnersModal.propTypes = {
    dataUser: PropTypes.object,
    pagePerso: PropTypes.bool,
    setPagePerso: PropTypes.func,
    iframe: PropTypes.bool,
    setIframe: PropTypes.func
};

export default PartnersModal;